export default __webpack_public_path__ + "static/media/doom2.ec62c7fb.gif";